export default import.meta.ROLLDOWN_FILE_URL_ODw0Jezds0q2jFaKUjcEHQ